module.exports = __webpack_public_path__ + "img/model-btn.67cf59a0.png";